import { PARTICIPATION_STUDENT_RETRIEVED } from './student-actions';

const initialState = null;

/**
 * Participation - Student Reducer
 *
 * Consumes PARTICIPATION_STUDENT_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case PARTICIPATION_STUDENT_RETRIEVED:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/participation/student/student-reducer.js